module.exports = __webpack_public_path__ + "static/media/customStep5a.a8ac8b5f.png";